import { Component, Input, OnInit } from '@angular/core';
import { ConstantService } from '../service/constant.service';

@Component({
  selector: 'app-view-skeleton',
  templateUrl: './view-skeleton.component.html',
  styleUrls: ['./view-skeleton.component.styl']
})
export class ViewSkeletonComponent implements OnInit {
  @Input() name: string;
  showNewUi = true;
  skeletonRecord = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12];

  constructor(
    public constant: ConstantService
  ) { }

  ngOnInit(): void {
  }
}
